import { useCallback } from 'react'
import { createGlobalState, useEffectOnce } from 'react-use'

import { api } from 'app/api'
import { reportTypeFromApiString } from 'app/common/api/requests/reports/data/_predefined/report-type-from-api-string'

import {
  GET_REPORTS_LIST,
  ReportsListResult,
  onlyAvailableReports,
} from 'app/common/api/requests/food/reports_list'

import { reportsArrange } from '../../../components/Reports/availableReports'

const defaultActiveItems: typeof reportsArrange = []

const useReportsGlobalState = createGlobalState({
  busy: false,
  loading: true,
  activeItems: defaultActiveItems,
})

export function useReportsEnabled() {
  const [activeState, setActiveState] = useReportsGlobalState()

  const request = useCallback(async () => {
    const res: ReportsListResult | null = await api.request(GET_REPORTS_LIST, {
      error: 'Запрос настроек отчетов не удался',
      // TODO add convertions & вынести в dataProviders из Settings/Additional/SectionReports
    })
    if (res) {
      setActiveState({
        busy: false,
        loading: false,
        activeItems: onlyAvailableReports(res).map((val) => reportTypeFromApiString(val)),
      })
    }
  }, [setActiveState])

  useEffectOnce(() => {
    setActiveState((state) => {
      const { busy } = state
      if (busy) {
        return state
      }
      request()
      return { ...state, busy: true }
    })
  })

  return {
    reportsEnabled: activeState.activeItems,
    loading: activeState.loading,
  }
}
